import { useState, useEffect } from "react";

export const useRewardsConfig = (open: boolean, tabActive: string, data?: any) => {

    const [isValidFormConfig, setIsValidForm] = useState<boolean>(true);
    const [formConfig, setForm] = useState({
		level_uuid: "",
		priority: "",
		coupons: [],
		period: { sdate: "", edate: "" },
		status: "",
		active: true
	})

	const coupon = {
		value_coupon: "",
		url_detail: "",
		description_coupon: "",
		title: "",
		active: true,
		icon_disabled_url: "",
		icon_enabled_url: "",
		type: ""
	}

	const onHandleChangeConfig = (field, field2, e) => {
		let f = formConfig
		let value = e.target.value

		if(field && !field2){
			f[field] = field === 'priority' ? value ? Number(value) : "" : value
		}
		if(field2){
			f[field][field2] = new Date(value).toJSON()
		}
		setForm(JSON.parse(JSON.stringify(f)));
        validateForm(f);
	}

    const validateForm = (f) => {
        if (f["level_uuid"] && f["priority"] && f["coupons"].length > 0 && f["period"]["sdate"] && f["period"]["edate"]) {
          setIsValidForm(false);
        } else {
          setIsValidForm(true);
        }
    };

	const addCoupon = () => {
		let f = formConfig;
		f["coupons"].push(coupon);
		setForm(JSON.parse(JSON.stringify(f)));
	}
	const deleteCoupon = (index) => {
        let f = formConfig;
        let subs = [];
        for(let i = 0; i < f['coupons'].length; i++){
            if(i !== index){
                subs.push(f['coupons'][i]);
            }
        }
        f['coupons'] = subs;
        setForm(JSON.parse(JSON.stringify(f)));
	}
    useEffect(() => {
		if(tabActive === "configuration" || tabActive === "history_config" ){
			if(open && data){
				setForm(JSON.parse(JSON.stringify({
					uuid: data["uuid"],
					level_uuid: data["level_uuid"],
					priority: data["priority"],
					coupons: data["coupons"],
					period: data["period"],
					status: "enabled",
					active: true
				})));
			}
			if(!open){
				setForm(JSON.parse(JSON.stringify({
					level_uuid: "",
					priority: "",
					coupons: [],
					period: { sdate: "", edate: "" },
					status: "enabled",
					active: true
				})));
				setIsValidForm(true);
			}
		}

		// eslint-disable-next-line react-hooks/exhaustive-deps
    }, [open && (tabActive === "configuration" || tabActive === "history_config") ])

    return { formConfig, isValidFormConfig, onHandleChangeConfig, deleteCoupon, addCoupon }
}